import {Box, Grid} from '@mui/material';
import {useFormContext} from 'react-hook-form';

import {dentalOfficeLeftFields, dentalOfficeRightFields} from '../../../forms-utils/form-schemas/dental-office';
import {renderFormFields} from '../../../forms-utils/renderFormFields';

const EmmaiDentalOfficeForm = () => {
  const {control} = useFormContext();
  const formPrefixName = 'officeInformation';

  return (
    <Box mt={-1}>
      <Grid
        container
        flexWrap={{
          xs: 'wrap',
          sm: 'nowrap'
        }}
      >
        <Grid item xs={12} sm={6} overflow="hidden">
          {renderFormFields(formPrefixName, dentalOfficeLeftFields, control)}
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          ml={{
            xs: 0,
            sm: 3
          }}
        >
          {renderFormFields(formPrefixName, dentalOfficeRightFields, control)}
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmmaiDentalOfficeForm;
